import Typography from "@mui/material/Typography"
import type { ReactNode } from "react"

interface TitleProps {
  children?: ReactNode
}

export function Title({ children }: TitleProps) {
  return (
    <Typography component="h2" variant="h4" color="primary" gutterBottom>
      {children}
    </Typography>
  )
}
